/* eslint-disable */
import React from 'react'

import PlayStore from '../../static/icons/ic-play-store.webp'
import AppsStore from '../../static/icons/ic-apps-store.webp'
import { Style } from './download.styles'

const Download = () => {
  return (
    <Style>
      <div className="card">
        <div style={{ paddingTop: '50px' }}>
          <b>Klik Untuk Download Aplikasi</b>
          <div className="link-apps">
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=halo.jasa.startup"
              className="smaller-hover android-store"
            >
              <img src={PlayStore} alt="halojasa/play-store" loading="lazy" />
            </a>
            <a
              target="_blank"
              href="https://apps.apple.com/app/apple-store/id1492671277?pt=119003762&ct=website%20halo%20jasa&mt=8"
              className="smaller-hover ios-store"
            >
              <img src={AppsStore} alt="halojasa/app-store" loading="lazy" />
            </a>
          </div>
        </div>
      </div>
    </Style>
  )
}

export default Download
